export default {
  userLogin: '/api/login',
  smallUploadFile: '/api/gmrfid-service-common/admin/upload/upFile',
  videoUploadFile: '/api/gmrfid-service-common/admin/upload/upLongFile',
  userOrganizeExport: '/api/gmrfid-service-user/admin/userOrganize/export', // PC端通讯录导出部门下的人员ß
  exportBill: '/api/gmrfid-service-pay/admin/bill/exportBill',
  exportFeeOrder: '/api/gmrfid-service-community/admin/feeOrder/exportBill',
  upFileInfo: '/api/gmrfid-service-common/upload/upFileInfo',
  exportVoteRecord: '/api/gmrfid-service-vote/admin/voteRecord/exportVoteRecord',
  export: '/api/gmrfid-service-website/admin/customer-maintains/export',
  exportOwner: '/api/gmrfid-service-community/admin/manager/exportOwner', // 导入业主
  exportHouse: '/api/gmrfid-service-community/admin/manager/exportHouse', // 导入房屋
  HouseImport: '/api/gmrfid-service-community/admin/house/import', // 公共房屋导入
  BuildingImport: '/api/gmrfid-service-community/admin/build/import', // 公共楼栋导入
  UserHouseImport: '/api/gmrfid-service-community/admin/userHouse/import', // 公共人口导入
};
